import { config } from '../../config'
import axios from './axios';

class BaseAPI {
  constructor() {
    this.baseURL = config.endpoints.api;
    this.headers = {
      "Content-Type" : 'application/json'
    }
  }
  /**
   * @method postData
   * @param {*} url 
   * @param {*} data 
   * @output Object response
   */
  
  async postData(url = '', data = {}) {   
    return await axios.post(url, data, { 
      headers: this.headers      
    })
  }

  /**
   * @method getData
   * @param {*} url 
   * @output Object response
   */
  async getData(url = '') {   
    return await axios.get(url, {
      headers: this.headers      
    })
  } 
}
export { BaseAPI };